import { CEDE_CEXS } from "@cede/types";

/**
 * Mapping of exchange IDs to their website URLs
 */
export const EXCHANGE_URLS: Record<string, string> = {
  [CEDE_CEXS.BINANCE]: "https://www.binance.com",
  [CEDE_CEXS.MEXC]: "https://www.mexc.com",
  [CEDE_CEXS.KUCOIN]: "https://www.kucoin.com",
  [CEDE_CEXS.BITGET]: "https://www.bitget.com",
  [CEDE_CEXS.CRYPTOCOM]: "https://crypto.com",
  [CEDE_CEXS.BYBIT]: "https://www.bybit.com",
  [CEDE_CEXS.GATEIO]: "https://www.gate.io",
  [CEDE_CEXS.COINBASE]: "https://www.coinbase.com",
  [CEDE_CEXS.BITMART]: "https://www.bitmart.com",
  [CEDE_CEXS.KRAKEN]: "https://www.kraken.com",
  [CEDE_CEXS.OKX]: "https://www.okx.com",
  [CEDE_CEXS.HTX]: "https://www.htx.com",
  [CEDE_CEXS.BITSTAMP]: "https://www.bitstamp.net",
  [CEDE_CEXS.BITFINEX]: "https://www.bitfinex.com",
};

/**
 * Get the exchange website URL for a given exchange ID
 * @param exchangeId The exchange identifier
 * @returns The exchange website URL or null if not found
 */
export const getExchangeUrl = (exchangeId: string): string | null => {
  return EXCHANGE_URLS[exchangeId] || null;
};
